import React, { useMemo } from 'react'
import classNames from 'classnames'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import {
  Form,
  Field,
  useFieldArray,
  resetForm,
  useWatch,
  WatchField,
  useForm,
  isEmpty
} from '../../form'
import { useHistory } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import InvoiceInputTable from './invoiceInputTable.component'
//import RenderDropZoneInput from '../../utils/dropzone'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import InvoiceInputMobileComponent from './invoiceInputMobile.component'
//import { QUICK_PAY_LIMIT } from '../../constants'
import CountrySelectField from '../common/countrySelectField'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import { withStyles } from '@material-ui/core/styles'
import {
  cancelEditInvoice,
  changeVATPercent,
  selectInvoiceCustomer,
  goToReview,
  enableCancelInvoice,
  getInvoiceUserEmail,
  getAdminUsersList,
  getInvoicesStart,
  getFinvoiceOperator,
  getCountryList,
  getUserCompanyUpdateInfo,
  getJournal,
  saveInvoiceDraft
} from '../../actions'
import { invoiceValidate } from '../../containers/validate'
import CompanySearchField from '../common/companySearchField'
import Dropzone from '../../utils/dropzone'
import { createMenuItems, calculateVat } from '../../utils/invoice.utils'
import IconTooltip from '../../utils/IconTooltip'
import { getInvoicesList } from '../../selectors/invoice.selector'
import { Controller } from 'react-hook-form'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import AddCostContainer from '../../containers/invoice/addCostForm.container'
import AddAllowanceContainer from '../../containers/invoice/addAllowanceForm.container'
import WorkshiftJournalContainer from '../../containers/invoice/workshiftJournal.container'
import VerificationAlertDialog from '../layout/verificationAlertDialog'

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      margin: '8px 15px'
    }
  },
  unselectButton: {
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      margin: '16px auto',
      float: 'left',
      width: '100%'
    }
  },
  select: {
    fontSize: '14px',
    marginTop: theme.spacing(4),
    cursor: 'pointer',
    border: '1px solid gray'
  },
  select2: {
    fontSize: '14px',
    marginTop: theme.spacing(4),
    cursor: 'pointer',
    border: '1px solid gray',
    width: '40%',
    [theme.breakpoints.down('900')]: {
      width: '50%'
    },
    [theme.breakpoints.down('500')]: {
      width: '100%'
    }
  },
  selectCustomer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    maxWidth: 300,
    fontSize: '14px',
    borderBottom: '1px solid gray'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  label: {
    [theme.breakpoints.down('370')]: {
      marginTop: 45
    }
  },
  radioButton: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  checkbox: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#808080'
  },
  checkbox1: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: 500,
    color: '#808080',
    paddingTop: '14px'
  },
  checkbox2: {
    display: 'none'
  },
  dropDownListsTextField: {
    position: 'relative'
  },
  dropDownLists: {
    position: 'absolute',
    width: '100%',
    zIndex: 3,
    background: '#f9f9f9'
  }
})

export const invoiceRowDefaultValues = {
  description: '',
  invoice_expense_id: -1,
  invoice_allowance_id: -1,
  start_date: new Date(),
  end_date: new Date(),
  quantity: '',
  unit: 'kpl',
  quantity_price: '',
  vat_percent: 25.5,
  sum_tax_free: '0',
  sum_with_vat: '0'
}

const groupInvoiceRowValue = {
  groupEmail: '',
  groupAmount: ''
}

let _date = new Date()
let _dateDue = new Date().setDate(_date.getDate() + 14)
export const defaultValues = {
  description: '',
  invoice_reference: '',
  billing_date: _date,
  due_date: _dateDue,
  overdue: 14,
  quick_pay: false,
  invoice_reminder: false,
  status: 0,
  country: '1',
  company_name: '',
  customer_type: 'company',
  business_id: '',
  VAT_id: '',
  person_to_contact: '',
  person_to_contact_email: '',
  person_to_quick_pay_email: '',
  delivery_address: '',
  zip_code: '',
  city: '',
  web_invoice: '',
  delivery_method: 'Sähköposti',
  finvoice_operator: '',
  invoice_price_selection: false,
  invoice_lang: false,
  sum: 0,
  total_sum: 0,
  rows: [invoiceRowDefaultValues],
  customer_id: '',
  is_credit_note: false,
  groupInvoiceRow: [groupInvoiceRowValue, groupInvoiceRowValue],
  groupTotalAmount: 0,
  groupRemainAmount: 0,
  groupInvoice: false,
  vat_selection: 25.5,
  addCost: false,
  addAllowance: false,
  addWorkshiftJournal: false
}

const InvoiceForm = ({ classes }) => {
  const {
    // companyLists,
    invoiceOperators,
    customers,
    isEdit,
    //isQuickPay,
    countryList,
    preventCancelInvoice,
    registeredUsersList,
    getRegisteredUserSuccess,
    attachedWorkShiftJournalIds
  } = useSelector((state) => state.invoice, shallowEqual)

  const userType = useSelector((state) => state.client.user.data[5])
  const selectedUser = useSelector((state) => state.adminUser.selectedUser)
  const noUserSelected = userType === 2 && !!!selectedUser?.email
  const user = useSelector((state) => state.profile.userData)

  // KAS-470 Invoice design changes
  React.useEffect(() => {
    if (userType == 2) {
      dispatch(getAdminUsersList())
    }
    dispatch(getInvoicesStart(selectedUser))
    dispatch(getFinvoiceOperator())
    dispatch(getCountryList())
    dispatch(getJournal())
  }, [userType, selectedUser])

  const showInvoiceItemLoader = useSelector(
    (state) => state.loader.showInvoiceItemLoader
  )
  const invoices = useSelector(getInvoicesList)
  const dispatch = useDispatch()
  const history = useHistory()

  const _invoiceOperators = ['', ...invoiceOperators]

  const form = useForm({
    name: 'invoice',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: (values) =>
      invoiceValidate(values, registeredUsersList, attachedWorkShiftJournalIds),
    keepEmptyValuesOnSubmit: false
  })

  const {
    control,
    getValues,
    // reset,
    formState: { errors }
  } = form

  const rowState = useFieldArray({ name: 'rows', control })
  const { fields: rowFields } = rowState

  const [submitFailed, setSubmitFailed] = React.useState(false)
  const [attemptingSubmit, setAttemptingSubmit] = React.useState(false)
  const [changeCustomerType, setChangeCustomerType] = React.useState(false)
  const [showPopupVerification, setShowPopupVerification] =
    React.useState(false)
  const [invoiceValues, setInvoiceValues] = React.useState({})

  function onSubmit(values) {
    if (!user.is_verified) {
      setShowPopupVerification(true)
      const formatedValues = formatInvoiceFormValues(values)
      setInvoiceValues(formatedValues)
    } else {
      const formatedValues = formatInvoiceFormValues(values)

      dispatch(goToReview(formatedValues))
      history.push('/dashboard/invoiceForm/review')
    }
  }

  function formatInvoiceFormValues(values) {
    values.vat = 0
    // KAS-356 If the invoice row is expense, don't need to calculate the vat
    // vat is calculated when adding expense to invoice
    values.rows.forEach((row) => {
      if (row?.vat && row.invoice_expense_id.toString() !== '-1') {
        row.vat = row.vat
      } else {
        row.vat = calculateVat(
          parseFloat(row.quantity),
          parseFloat(row.quantity_price),
          row.vat_percent,
          values.invoice_price_selection,
          row.invoice_expense_id.toString() !== '-1',
          row.invoice_allowance_id.toString() !== '-1'
        )
      }
      values.vat += row.vat
    })

    if (values.delivery_method === 'KIRJEPOSTI') {
      values.web_invoice = 'TULOSTUS'
    }
    return values
  }

  function removeRow(index) {
    rowState.remove(index)
  }

  function addRow(values) {
    if (
      values.vat_percent === 'building_service' ||
      values.vat_percent === 'vat_abroad'
    ) {
      values.vat_percent = 0
    }
    rowState.append(values)
  }

  function setValue(name, value) {
    form?.setValue(name, value)
  }

  function clearErrors(fields) {
    if (fields) {
      form?.clearErrors(fields)
    } else {
      form?.clearErrors()
    }
  }

  function selectCustomer(e) {
    if (e.target.value >= 0) {
      const _customer = customers
        .filter((el) => e.target.value === el.customer_id)
        .pop()
      dispatch(selectInvoiceCustomer(_customer, getValues()))
    } else {
      dispatch(resetForm('invoice'))
    }
  }

  const isExpenseAllowanceRow = useMemo(
    () =>
      rowFields.some(
        (row) =>
          row.invoice_expense_id.toString() !== '-1' ||
          row.invoice_allowance_id.toString() !== '-1'
      ),
    [rowFields]
  )

  React.useEffect(() => {
    if (attemptingSubmit && !isEmpty(errors)) {
      setSubmitFailed(true)
      setAttemptingSubmit(false)
    }
  }, [attemptingSubmit, setSubmitFailed, errors])

  React.useEffect(() => {
    if (preventCancelInvoice) {
      dispatch(enableCancelInvoice())
    }
  }, [preventCancelInvoice])

  React.useEffect(() => {
    dispatch(getInvoiceUserEmail(0))
    dispatch(getUserCompanyUpdateInfo())
  }, [])

  // KAS-459 Group invoice
  const [groupEmailCount, setGroupEmailCount] = React.useState(1)
  const groupInvoiceRowState = useFieldArray({
    name: 'groupInvoiceRow',
    control
  })
  const { fields: groupInvoiceFields } = groupInvoiceRowState

  const [warnGroupAmount, setWarnGroupAmount] = React.useState('')

  // KAS-417 Quick pay bug
  const current_date = new Date()
  const watch = useWatch({
    fields: [
      'company_name',
      'business_id',
      'total_sum',
      'groupTotalAmount',
      'groupInvoiceRow',
      'quick_pay',
      'groupInvoice',
      'vat_selection',
      'customer_type',
      'rows'
    ],
    control
  })
  const company_name = watch.company_name
  const business_id = watch.business_id
  const totalInvoiceInputSum = parseFloat(watch.total_sum)
  const groupTotalAmount = parseFloat(watch.groupTotalAmount)
  const quickPay = watch.quick_pay
  const groupInvoice = watch.groupInvoice
  const customer_type = watch.customer_type

  const isGroupAmountEmpty = useMemo(() => {
    const areAllGroupAmountsFilled = watch.groupInvoiceRow
      ? watch.groupInvoiceRow.every((row) => row.groupAmount > 0)
      : false
    return areAllGroupAmountsFilled
  }, [watch.groupInvoiceRow])

  let quick_pay_overdue_by_customer = []
  if (company_name !== '' && business_id !== '') {
    quick_pay_overdue_by_customer = invoices.filter(
      (inv) =>
        inv.instant_payment === 'quick_pay' &&
        (inv.status === 3 || inv.status === 5) &&
        inv.remindersent === 1 &&
        current_date > new Date(inv.due_date) &&
        inv.business_id === business_id
    )
  }
  let disable_quick_pay
  if (quick_pay_overdue_by_customer.length >= 1) {
    disable_quick_pay = true
  } else {
    disable_quick_pay = false
  }

  const calculateGroupRowAmount = () => {
    const openedRowsCount = watch.groupInvoiceRow.length
    const groupInvoiceRow = watch.groupInvoiceRow
    let adjustedRowCount = 0

    const sumOfTouchedRows = groupInvoiceRow.reduce((acc, row) => {
      if (parseFloat(row.groupAmount) > 0) {
        adjustedRowCount += 1
        return acc + parseFloat(row.groupAmount)
      } else return acc
    }, 0)

    if (openedRowsCount > 0) {
      let amountToDistribute =
        (totalInvoiceInputSum - sumOfTouchedRows) /
        (openedRowsCount - adjustedRowCount)
      amountToDistribute = parseFloat(amountToDistribute.toFixed(2))

      for (let i = 0; i < openedRowsCount; i++) {
        if (
          !parseFloat(groupInvoiceRow[i].groupAmount) ||
          parseFloat(groupInvoiceRow[i].groupAmount) === 0
        ) {
          setValue(`groupInvoiceRow.${i}.groupAmount`, amountToDistribute)
        }
      }

      // Adjust the last row to receive the maximum amount if rounding issue occurs
      const lastRowIndex = openedRowsCount - 1
      const totalAllocatedAmount =
        (openedRowsCount - adjustedRowCount - 1) * amountToDistribute
      const remainingAmount =
        totalInvoiceInputSum - sumOfTouchedRows - totalAllocatedAmount

      if (
        parseFloat(groupInvoiceRow[lastRowIndex].groupAmount) === 0 ||
        !groupInvoiceRow[lastRowIndex].groupAmount
      ) {
        setValue(`groupInvoiceRow.${lastRowIndex}.groupAmount`, remainingAmount)
      }
    }
    clearErrors('groupInvoiceRow')
    clearErrors('groupTotalAmount')
  }

  const removeGroupInvoiceRow = (index) => {
    groupInvoiceRowState.remove(index)
    setGroupEmailCount((prevCount) => prevCount - 1)
    clearErrors('groupInvoiceRow')
    clearErrors('groupTotalAmount')
  }

  const addGroupInvoiceRow = () => {
    if (groupTotalAmount < totalInvoiceInputSum && groupEmailCount < 6) {
      const newRow = {
        groupEmail: '',
        groupAmount: ''
      }
      groupInvoiceRowState.append(newRow)
      setGroupEmailCount((prevCount) => prevCount + 1)
      clearErrors('groupInvoiceRow')
    } else {
      if (groupTotalAmount > totalInvoiceInputSum) {
        setWarnGroupAmount('exceeds')
      } else {
        setWarnGroupAmount('reached')
      }
    }
  }

  let isGroupInvoiceEnabled = groupInvoice ? true : false

  const isGroupInvoice = isGroupInvoiceEnabled || groupTotalAmount > 0

  const isQuickPay = quickPay ? true : false

  const resetGroupInvoice = () => {
    const openedRowsCount = watch.groupInvoiceRow.length

    for (let i = 0; i < openedRowsCount; i++) {
      setValue(`groupInvoiceRow.${i}.groupAmount`, '')

      if (i !== 0) {
        setValue(`groupInvoiceRow.${i}.groupEmail`, '')
      }
    }
    setValue('groupTotalAmount', 0)
    clearErrors('groupInvoiceRow')
    clearErrors('groupTotalAmount')
  }

  React.useEffect(() => {
    if (getRegisteredUserSuccess) {
      watch.groupInvoiceRow.forEach((row, index) => {
        if (registeredUsersList.some((obj) => obj.email === row.groupEmail)) {
          clearErrors(`groupInvoiceRow.${index}.groupEmail`)
        }
      })
    }
  }, [getRegisteredUserSuccess])

  React.useEffect(() => {
    if (attachedWorkShiftJournalIds.length > 0) {
      clearErrors('attachedJournal')
    }
  }, [attachedWorkShiftJournalIds])
  const saveInvDraft = () => {
    dispatch(saveInvoiceDraft(invoiceValues))
  }

  return (
    <Translation>
      {(t) => (
        <div className="container">
          <div className="row">
            {userType == 2 && <UserSelectorContainer></UserSelectorContainer>}
          </div>
          <div className="row" id="invoice-info-scroll-section">
            <div className="dashboard-content-header">
              {isEdit ? (
                <h1>{t('invoice.header')}</h1>
              ) : (
                <h1>{t('invoice.header2')}</h1>
              )}
            </div>
          </div>
          <Form {...form}>
            <div className="row">
              <div
                className="dashboard-content-header"
                style={{ paddingLeft: 15 }}
              >
                <div
                  className="panel-body"
                  style={{ textAlign: 'center', padding: '0px' }}
                >
                  <div className="col-xs-12 col-sm-12 col-lg-4"></div>
                  <div
                    className={
                      !mobileView ? 'col-xs-12 col-sm-12 col-lg-4' : undefined
                    }
                  >
                    <Controller
                      name="is_credit_note"
                      control={control}
                      render={({ field }) => <input type="hidden" {...field} />}
                    />
                    <Field
                      name="customer_type"
                      inputType="radiogroup"
                      className={classes.radioButton}
                      horizontal
                      // KAS-339 SELECTED_CUSTOMER_TYPE action don't use any more, use WatchField instead
                      options={[
                        {
                          label: t('invoice.company'),
                          value: 'company'
                        },
                        {
                          label: t('invoice.private'),
                          value: 'private_person'
                        }
                      ]}
                      control={control}
                      onChange={(e) => {
                        if (e.target.value === 'private_person') {
                          setChangeCustomerType(true)
                          setValue('quick_pay', false)
                          setValue('vat_selection', 25.5)
                        }
                      }}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-12 col-lg-4"></div>
                </div>
                <div style={{ whiteSpace: 'nowrap' }}>
                  <Field
                    name="customer_id"
                    label={t('invoice.label')}
                    className={classes.selectCustomer}
                    inputType="select"
                    disabled={isEdit}
                    control={control}
                    onChange={selectCustomer}
                  >
                    {_createCustomerMenuItems(customers)}
                  </Field>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-6 col-lg-4">
                  {customerInfo(
                    classes,
                    countryList,
                    control,
                    setValue,
                    customer_type,
                    watch
                  )}
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-4">
                  <InvoiceDeliveryMethod
                    classes={classes}
                    invoiceOperators={_invoiceOperators}
                    clearErrors={clearErrors}
                    control={control}
                  />
                </div>
                <div className="col-xs-12 col-sm-12 col-lg-4">
                  {invoiceInfo(classes, setValue, control)}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <WatchField control={control} fields={['customer_type']}>
                    {(watch) => (
                      <>
                        <InvoiceAdditionalInformation
                          form={form}
                          changeVATPercent={changeVATPercent}
                          classes={classes}
                          control={control}
                          rowFields={rowFields}
                          disable_quick_pay={disable_quick_pay}
                          setValue={setValue}
                          disable_building_service={
                            watch.customer_type === 'private_person'
                          }
                          changeCustomerType={changeCustomerType}
                          isGroupInvoice={isGroupInvoice}
                        />
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 20px',
                            margin: '-20px 0 0 0'
                          }}
                        >
                          <Field
                            name="invoice_lang"
                            label={t('invoice.send_invoice_english')}
                            inputType="checkbox"
                            className={classes.checkbox}
                            control={control}
                          />
                        </div>
                      </>
                    )}
                  </WatchField>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div
                      className="panel-heading"
                      id="invoice-items-scroll-section"
                    >
                      <h3 className="panel-title">{t('invoice.row')}</h3>
                    </div>
                    <WatchField control={control} fields={['customer_type']}>
                      {(watch) => (
                        <>
                          {mobileView ? (
                            <InvoiceInputMobileComponent
                              fields={rowFields}
                              addRow={addRow}
                              removeRow={removeRow}
                              setValue={setValue}
                              control={control}
                              clearErrors={clearErrors}
                              getValues={getValues}
                              shouldDisableVat0={
                                watch.customer_type === 'private_person'
                              }
                              groupInvoiceFields={groupInvoiceFields}
                              addGroupInvoiceRow={addGroupInvoiceRow}
                              removeGroupInvoiceRow={removeGroupInvoiceRow}
                              groupEmailCount={groupEmailCount}
                              totalInvoiceInputSum={totalInvoiceInputSum}
                              groupTotalAmount={groupTotalAmount}
                              isExpenseAllowanceRow={isExpenseAllowanceRow}
                              calculateGroupRowAmount={calculateGroupRowAmount}
                              isQuickPay={isQuickPay}
                              resetGroupInvoice={resetGroupInvoice}
                              isGroupAmountEmpty={isGroupAmountEmpty}
                            />
                          ) : (
                            <InvoiceInputTable
                              fields={rowFields}
                              addRow={addRow}
                              removeRow={removeRow}
                              setValue={setValue}
                              control={control}
                              clearErrors={clearErrors}
                              getValues={getValues}
                              shouldDisableVat0={
                                watch.customer_type === 'private_person'
                              }
                              groupInvoiceFields={groupInvoiceFields}
                              addGroupInvoiceRow={addGroupInvoiceRow}
                              removeGroupInvoiceRow={removeGroupInvoiceRow}
                              groupEmailCount={groupEmailCount}
                              totalInvoiceInputSum={totalInvoiceInputSum}
                              groupTotalAmount={groupTotalAmount}
                              isExpenseAllowanceRow={isExpenseAllowanceRow}
                              calculateGroupRowAmount={calculateGroupRowAmount}
                              isQuickPay={isQuickPay}
                              resetGroupInvoice={resetGroupInvoice}
                              isGroupAmountEmpty={isGroupAmountEmpty}
                            />
                          )}
                        </>
                      )}
                    </WatchField>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">
                        {t('invoice.attachmentTitle')}
                      </h3>
                    </div>
                    <div className="panel-body">
                      <div>
                        <p
                          className="panel-title"
                          style={{ marginBottom: '10px' }}
                        >
                          {t('invoice.attachmentInfo')}
                        </p>
                      </div>
                      <div>
                        <Dropzone />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          <AddCostContainer
            invoiceFormControl={control}
            getValuesInvoiceForm={getValues}
          />
          <AddAllowanceContainer
            invoiceFormControl={control}
            getValuesInvoiceForm={getValues}
          />
          <WorkshiftJournalContainer
            invoiceFormControl={control}
            isEditInvoice={isEdit}
            errors={errors}
            attachedWorkShiftJournalIds={attachedWorkShiftJournalIds}
          />
          <Form {...form}>
            <div
              className="row"
              style={{ textAlign: 'center', marginRight: '-6px' }}
            >
              <div className="pull-right">
                {isEdit ? (
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={(e) => {
                      dispatch(cancelEditInvoice(e))
                    }}
                    disabled={noUserSelected}
                  >
                    {t('invoice.button')}
                  </Button>
                ) : null}
                <>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => setAttemptingSubmit(true)}
                    disabled={noUserSelected}
                    type="submit"
                  >
                    {t('invoice.button2')}
                  </Button>
                </>
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={(submitFailed && !isEmpty(errors)) || !!warnGroupAmount}
              autoHideDuration={4000}
              onClose={() => {
                if (!!warnGroupAmount) setWarnGroupAmount('')
                else setSubmitFailed(false)
              }}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={
                  !!warnGroupAmount
                    ? warnGroupAmount === 'reached'
                      ? t('validation.groupTotalAmountLimitReached')
                      : t('validation.groupTotalAmountLimitExceeds')
                    : errors?.rows ===
                        'Invoice cannot contain both positive and negative rows.' ||
                      errors?.rows === 'Credit note amount cannot be positive.'
                    ? t('invoice.msg2')
                    : errors?.rows === 'Quick pay exceeded'
                    ? t('invoice.quickPay')
                    : errors?.rows ===
                      'Quick pay is not allowed for negative invoices.'
                    ? t('invoice.msg3')
                    : t('invoice.msg')
                }
              />
            </Snackbar>
            <Dialog
              open={showInvoiceItemLoader}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('login.dialog')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
            {showPopupVerification ? (
              <VerificationAlertDialog
                open={showPopupVerification}
                close={() => setShowPopupVerification(false)}
                saveInvoice={() => saveInvDraft()}
              />
            ) : null}
          </Form>
        </div>
      )}
    </Translation>
  )
}

const customerInfo = (
  classes,
  countryList,
  control,
  setValue,
  customer_type,
  watch
) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{t('invoice.panelh3')}</h3>
          </div>
          <div className="panel-body" style={{ marginBottom: '25px' }}>
            <div>
              <CountrySelectField
                t={t}
                classes={classes}
                countryList={countryList}
                control={control}
                form="invoice"
                setValue={setValue}
                watch={watch}
              />
            </div>
            <div className={classes.dropDownListsTextField}>
              <CompanySearchField
                form="invoice"
                name="company_name"
                control={control}
              />
            </div>
            <div>
              <WatchField control={control} fields={'country'}>
                {(watch) =>
                  watch.country != 1 ? (
                    <WatchField control={control} fields="vat_selection">
                      {(fields) =>
                        fields.vat_selection === 'building_service' ? (
                          <Field
                            name="business_id"
                            inputType="textfield"
                            label={t('asiakkaat.label8')}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                            control={control}
                          />
                        ) : (
                          // KAS-339 Using watchfield to watch, if customer_type is company, business_id is required
                          <WatchField control={control} fields="customer_type">
                            {(watch) => (
                              <Field
                                name="business_id"
                                inputType="textfield"
                                label={
                                  watch.customer_type === 'company'
                                    ? t('asiakkaat.label3') + '*'
                                    : t('asiakkaat.label3')
                                }
                                className={classNames(
                                  classes.textField,
                                  classes.resize
                                )}
                                control={control}
                              />
                            )}
                          </WatchField>
                        )
                      }
                    </WatchField>
                  ) : (
                    // KAS-339 Using watchfield to watch, if customer_type is company, business_id is required
                    // <WatchField control={control} fields="customer_type">
                    //   {(watch) => (
                    <Field
                      name="business_id"
                      inputType="textfield"
                      label={
                        customer_type === 'company'
                          ? t('asiakkaat.label3') + '*'
                          : t('asiakkaat.label3')
                      }
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                    />
                    //   )}
                    // </WatchField>
                  )
                }
              </WatchField>
            </div>
            <div>
              <Field
                name="person_to_contact"
                inputType="textfield"
                label={t('asiakkaat.label4')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
              />
            </div>
            <div>
              <Field
                name="person_to_contact_email"
                inputType="textfield"
                label={t('asiakkaat.label5')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
              />
            </div>
            <div>
              <Field
                name="person_to_quick_pay_email"
                inputType="textfield"
                label={t('asiakkaat.label7')}
                className={classNames(
                  classes.textField,
                  classes.resize,
                  classes.label
                )}
                control={control}
              />
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)

const InvoiceDeliveryMethod = ({
  classes,
  invoiceOperators,
  clearErrors,
  control
}) => {
  return (
    <Translation>
      {(t) => {
        return (
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">{t('invoice.panelh3b')}</h3>
            </div>
            <div
              className="panel-body"
              style={{ marginBottom: '25px', whiteSpace: 'nowrap' }}
            >
              <div>
                <Field
                  name="delivery_method"
                  inputType="select"
                  label={t('invoice.laskun')}
                  className={classes.select}
                  onChange={(e) => {
                    if (e.target.value === 'Sähköposti') {
                      clearErrors([
                        'delivery_address',
                        'zip_code',
                        'city',
                        'web_invoice',
                        'finvoice_operator'
                      ])
                    } else if (e.target.value === 'Kirjeposti') {
                      clearErrors(['web_invoice', 'finvoice_operator'])
                    }
                  }}
                  control={control}
                >
                  <MenuItem value="Sähköposti">{t('Sähköposti')}</MenuItem>
                  <MenuItem value="Kirjeposti">{t('Kirjeposti')}</MenuItem>
                  <MenuItem value="Verkkolasku">{t('Verkkolasku')}</MenuItem>
                </Field>
              </div>
              <div>
                <WatchField control={control} fields="delivery_method">
                  {(watch) => (
                    <Field
                      name="delivery_address"
                      inputType="textfield"
                      label={
                        watch.delivery_method !== 'Kirjeposti' &&
                        watch.delivery_method !== 'Verkkolasku'
                          ? t('invoice.label6').replace(' *', '')
                          : t('invoice.label6')
                      }
                      className={classNames(classes.textField, classes.resize)}
                      control={control}
                    />
                  )}
                </WatchField>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '46%' }}>
                  <WatchField control={control} fields="delivery_method">
                    {(watch) => (
                      <Field
                        name="zip_code"
                        inputType="textfield"
                        label={
                          watch.delivery_method !== 'Kirjeposti' &&
                          watch.delivery_method !== 'Verkkolasku'
                            ? t('invoice.posti').replace(' *', '')
                            : t('invoice.posti')
                        }
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    )}
                  </WatchField>
                </div>
                <div style={{ width: '46%', whiteSpace: 'nowrap' }}>
                  <WatchField control={control} fields="delivery_method">
                    {(watch) => (
                      <Field
                        name="city"
                        inputType="textfield"
                        label={
                          watch.delivery_method !== 'Kirjeposti' &&
                          watch.delivery_method !== 'Verkkolasku'
                            ? t('invoice.posti2').replace(' *', '')
                            : t('invoice.posti2')
                        }
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    )}
                  </WatchField>
                </div>
              </div>
              <div>
                <WatchField fields={'delivery_method'} control={control}>
                  {(watch) => (
                    <Field
                      name="web_invoice"
                      inputType="textfield"
                      label={
                        watch.delivery_method !== 'Sähköposti' &&
                        watch.delivery_method !== 'Kirjeposti'
                          ? t('invoice.verkko') + '*'
                          : t('invoice.verkko')
                      }
                      className={classNames(classes.textField, classes.resize)}
                      disabled={watch.delivery_method === 'Kirjeposti'}
                      displayValue={
                        watch.delivery_method === 'Kirjeposti'
                          ? 'TULOSTUS'
                          : undefined
                      }
                      control={control}
                    />
                  )}
                </WatchField>
              </div>
              <div>
                <WatchField fields={'delivery_method'} control={control}>
                  {(watch) => (
                    <Field
                      name="finvoice_operator"
                      inputType="select"
                      label={
                        watch.delivery_method !== 'Sähköposti' &&
                        watch.delivery_method !== 'Kirjeposti'
                          ? t('invoice.verkko2') + '*'
                          : t('invoice.verkko2')
                      }
                      className={classes.select}
                      control={control}
                    >
                      {createMenuItems(invoiceOperators)}
                    </Field>
                  )}
                </WatchField>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const invoiceInfo = (classes, setValue, control) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{t('invoice.laskunh3')}</h3>
          </div>
          <div className="panel-body" style={{ marginBottom: '25px' }}>
            <div>
              <div>
                <Field
                  name="billing_date"
                  label={t('invoice.labela1')}
                  className={classNames(classes.textField, classes.resize)}
                  inputType="datepicker"
                  control={control}
                  minDate={new Date().setMonth(new Date().getMonth() - 1)}
                  // KAS-340 Date of invoicing is limited in 1 month back
                />
              </div>
              <div>
                <Field
                  name="overdue"
                  inputType="select"
                  label={t('invoice.labela2')}
                  className={classes.select}
                  control={control}
                >
                  {_createOverdueItems(t)}
                </Field>
              </div>
            </div>
            <div>
              <DueDateField
                t={t}
                classes={classes}
                setValue={setValue}
                control={control}
              />
            </div>
            <div>
              <Field
                name="invoice_reference"
                inputType="textfield"
                label={t('invoice.labela4')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
              />
            </div>
            <div>
              <Field
                name="description"
                inputType="textfield"
                label={t('invoice.labela5')}
                className={classNames(classes.textField, classes.resize)}
                control={control}
              />
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)

const DueDateField = ({ t, classes, setValue, control }) => {
  const watch = useWatch({
    fields: ['overdue', 'billing_date'],
    control
  })
  const dueDate = new Date(watch.billing_date.valueOf())
  dueDate.setDate(watch.billing_date.getDate() + watch.overdue)

  return (
    <Field
      name="due_date"
      label={t('invoice.labela3')}
      className={classNames(classes.textField, classes.resize)}
      inputType="datepicker"
      setValue={() => setValue('due_date', dueDate)}
      watchValue={dueDate}
      disabled={true}
      control={control}
    />
  )
}

export const InvoiceAdditionalInformation = ({
  changeVATPercent,
  classes,
  control,
  disable_quick_pay,
  disable_building_service,
  changeCustomerType,
  setValue,
  isGroupInvoice
}) => {
  const dispatch = useDispatch()

  // KAS-379 new quick pay feature
  let isDisabled = false
  const country = useWatch({
    fields: 'country',
    control: control
  })
  const customer_type = useWatch({
    fields: 'customer_type',
    control: control
  })
  const watchRows = useWatch({
    fields: 'rows',
    control: control
  })

  customer_type.customer_type === 'private_person' ||
  parseInt(country.country) !== 1
    ? (isDisabled = true)
    : (isDisabled = false)

  // InvoiceAdditionalInformation is functional component
  // So the setState call need to be wrapped into useEffect
  React.useEffect(() => {
    if (disable_quick_pay || isDisabled) {
      setValue('quick_pay', false)
    }
  }, [disable_quick_pay, isDisabled])

  React.useEffect(() => {
    if (changeCustomerType && disable_building_service) {
      dispatch(changeVATPercent(25.5, watchRows.rows))
    }
  }, [changeCustomerType, disable_building_service])

  const mobileAdditionalInvoiceDetails =
    window.innerWidth <= 768 ? 'wrap' : 'nowrap'

  return (
    <Translation>
      {(t) => {
        return (
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="panel-title">{t('invoice.h3b')}</h3>
            </div>
            <div
              className="panel-body"
              style={{
                padding: '8px 20px',
                alignItems: 'flex-start',
                flexGrow: 1
              }}
            >
              <WatchField control={control} fields={'quick_pay'}>
                {(fields) =>
                  fields.quick_pay === true ? (
                    <div
                      style={{
                        marginBottom: '8px',
                        paddingTop: '0px',
                        fontSize: '8px'
                      }}
                    >
                      {t('invoice.quickPayInfo')}
                    </div>
                  ) : null
                }
              </WatchField>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: mobileAdditionalInvoiceDetails
                }}
              >
                <Field
                  name="quick_pay"
                  label={t('invoice.button3')}
                  inputType="checkbox"
                  control={control}
                  className={classes.checkbox}
                  disabled={disable_quick_pay || isDisabled || isGroupInvoice}
                />

                <Field
                  name="invoice_reminder"
                  label={t('invoice.button4')}
                  inputType="checkbox"
                  control={control}
                  className={classes.checkbox}
                />
              </div>
            </div>
            <div
              className="panel-body"
              style={{
                padding: '0px 20px',
                alignItems: 'flex-start',
                flexGrow: 1
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: mobileAdditionalInvoiceDetails
                }}
              >
                <Field
                  name="invoice_price_selection"
                  label={
                    <React.Fragment>
                      {t('invoice.priceSelection')}{' '}
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%'
                          }}
                        >
                          <IconTooltip
                            tooltipShow={t('asiakkaat.tooltip1')}
                            style={{
                              display: 'inline-block',
                              verticalAlign: 'middle',
                              position: 'relative',
                              top: '0.125em'
                            }}
                          />
                        </div>
                      </span>
                    </React.Fragment>
                  }
                  inputType="checkbox"
                  className={classes.checkbox}
                  control={control}
                />
                <Field
                  name="vat_selection"
                  inputType="select"
                  className={classNames(classes.select2, classes.resize)}
                  control={control}
                  style={{
                    marginTop: -30,
                    minWidth: '70%',
                    maxWidth: '100%',
                    marginBottom: 20
                  }}
                  onChange={(e) => {
                    dispatch(changeVATPercent(e.target.value, watchRows.rows))
                  }}
                >
                  <MenuItem value={25.5}>
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)' // 10px min, 12px max & 2vw responsive scalling based on width
                      }}
                    >
                      {t('invoice.vat_25_5')}
                    </span>
                  </MenuItem>
                  <MenuItem value={24}>
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.vat_24')}
                    </span>
                  </MenuItem>
                  <MenuItem
                    value="building_service"
                    disabled={disable_building_service}
                  >
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.builderCheckBox')}
                    </span>
                  </MenuItem>
                  <MenuItem value={14}>
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.vat_14')}
                    </span>
                  </MenuItem>
                  <MenuItem value={10}>
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.vat_10')}
                    </span>
                  </MenuItem>
                  <MenuItem value={0} disabled={disable_building_service}>
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.vat_0')}
                    </span>
                  </MenuItem>
                  <MenuItem
                    value="vat_abroad"
                    disabled={
                      parseInt(country.country) !== 1 &&
                      !disable_building_service
                        ? false
                        : true
                    }
                  >
                    <span
                      style={{
                        width: '100%',
                        fontSize: 'clamp(10px, 2vw, 12px)'
                      }}
                    >
                      {t('invoice.vat_abroad')}
                    </span>
                  </MenuItem>
                </Field>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const _createCustomerMenuItems = (customers) => {
  return customers
    .sort((a, b) => a.company_name.localeCompare(b.company_name))
    .map((c) => (
      <MenuItem key={c.customer_id} value={c.customer_id}>
        {c.company_name}
      </MenuItem>
    ))
}

const _createOverdueItems = (t) => {
  let overdueItems = []
  for (let i = 0; i <= 60; i++) {
    overdueItems.push(
      <MenuItem key={i} value={i}>
        {`${i} ${t('invoice.days')}`}
      </MenuItem>
    )
  }
  return overdueItems
}

export default withStyles(styles)(InvoiceForm)
